import React from 'react';
import {
  Drawer,
  Avatar,
  Typography,
  Divider,
  List,
  Space,
  App as AntdApp,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPenToSquare,
  faLock,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'; 
import { handleLogout, getCurrentUser } from '../utils/auth'; 
import { getAppUrlInfo } from '../utils/urls';
//import { User } from '../types/users.types';

const { Title, Text } = Typography;

// ❗Style constants for anything Tailwind can't handle
const closeIconStyle: React.CSSProperties = {
  fontSize: 20,
  cursor: 'pointer',
};

const drawerBodyStyle: React.CSSProperties = {
  padding: 0,
};

const signOutStyle: React.CSSProperties = {
  color: '#f26b1d',
  cursor: 'pointer',
};



const UserDrawer: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  const { accountsUrl, currentUrl } = getAppUrlInfo(); // Use if you want to build URL dynamically// Drawer options
  const drawerItems = [
    {
      icon: faPenToSquare,
      label: 'Edit Profile',
      href: `${accountsUrl}/edit-profile?backTo=${currentUrl}`,
    },
    {
      icon: faLock,
      label: 'Change Password',
      href: `${accountsUrl}/reset-password?backTo=${currentUrl}`,
    },
  ];
  const { message } = AntdApp.useApp(); 
  const user: any | null = getCurrentUser();

  const onLogout = () => {
    message.success('Logged out successfully!');
    handleLogout();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="right"
      width={360}
      closable={false}
      styles={{ body: drawerBodyStyle }}
    >
      {/* Close Button */}
      <div className="text-right px-5 pt-3">
        <FontAwesomeIcon icon={faXmark} style={closeIconStyle} onClick={onClose} />
      </div>

      {/* User Info Section */}
      <div className="flex flex-col items-center text-center px-6 pb-4">
        <Avatar
          size={100}
          style={{ backgroundColor: '#f26b1d' }}
        />
        <Title level={5} className="mt-4 mb-2">
          {user?.fullName ?? 'User'}
        </Title>
        <Text className="text-sm mb-0.5">
          Role: {typeof user?.role === 'string' ? user.role : user?.role?.name ?? 'Role'}
        </Text>
        <Text className="text-sm mb-0.5">Mobile: {user?.phone ?? 'N/A'}</Text>
        <Text className="text-sm">{user?.email ?? ''}</Text>
        <div className="mt-4 font-medium" style={signOutStyle} onClick={onLogout}>
          Sign Out
        </div>
      </div>

      <Divider className="my-0" />

      {/* Drawer Navigation */}
      <div className="px-4">
        <List
          itemLayout="horizontal"
          dataSource={drawerItems}
          renderItem={(item) => (
            <List.Item className="px-6 py-3 hover:bg-gray-50 cursor-pointer">
              <Space size="large">
                <FontAwesomeIcon icon={item.icon} />
                <a
                  href={item.href}
                  /* target="_blank"  */// Opens the link in a new tab
                  rel="noopener noreferrer" // Security best practice
                  className="text-gray-700 hover:text-gray-900"
                >
                  {item.label}
                </a>
              </Space>
            </List.Item>
          )}
        />
      </div>
    </Drawer>
  );
};

export default UserDrawer;
